'use client';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { useState } from 'react';

interface ShowMoreLessProps<T> {
  items?: T[];
  initialShowCount?: number;
}

export function useShowMoreLess<T>({
  items = [],
  initialShowCount = 6,
}: ShowMoreLessProps<T>) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { texts } = useTranslation();

  function toggleShowMore() {
    setIsExpanded(!isExpanded);
  }

  const initiallyVisibleItems = isExpanded
    ? items
    : items.slice(0, initialShowCount);
  const initiallyHiddenItems = isExpanded ? [] : items.slice(initialShowCount);

  const buttonText = isExpanded
    ? texts.use_show_more_less.show_less
    : texts.use_show_more_less.show_more;

  return {
    initiallyVisibleItems,
    initiallyHiddenItems,
    toggleShowMore,
    isExpanded,
    buttonText,
    showAction: items.length > initialShowCount,
  };
}
